import {NgModule} from '@angular/core';
import {UiButtonComponent} from '../ui/ui-button/ui-button.component';
import {UiIconComponent} from '../ui/ui-icon/ui-icon.component';
import {MatAutocompleteModule} from '@angular/material/autocomplete';
import {RouterModule} from '@angular/router';
import {SharedSearchModule} from '../../app-common/shared-search.module';
import {SharedModule} from '../../app-common/shared.module';
import {SearchWidgetV3PlaceholderComponent} from './components/search-widget-v3-placeholder/search-widget-v3-placeholder.component';
import {SearchWidgetV3WrapperComponent} from './components/search-widget-v3-wrapper/search-widget-v3-wrapper.component';
import {SearchWidgetV3Component} from './components/search-widget-v3/search-widget-v3.component';
import {SearchWidgetV3MobileComponent} from './components/search-widget-v3-mobile/search-widget-v3-mobile.component';
import {SearchWidgetV3MobileExpandedComponent} from './components/search-widget-v3-mobile-expanded/search-widget-v3-mobile-expanded.component';
import {SearchWidgetV3FreeSearchFormComponent} from './components/search-widget-v3-free-search-form/search-widget-v3-free-search-form.component';
import {UiIconButtonComponent} from '../ui/ui-icon-button/ui-icon-button.component';
import {SearchWidgetV3PlacesFormComponent} from './components/search-widget-v3-places-form/search-widget-v3-places-form.component';
import {SearchWidgetV3SuggestionsComponent} from './components/search-widget-v3-suggestions/search-widget-v3-suggestions.component';
import {SearchWidgetV3StateService} from './services/search-widget-v3-state.service';
import {SearchWidgetV3ManagerService} from './services/search-widget-v3-manager.service';
import {SearchCategoriesMobilePanelV3Component} from './components/search-categories-mobile-panel-v3/search-categories-mobile-panel-v3.component';
import {SearchPlacesMobilePanelV3Component} from './components/search-places-mobile-panel-v3/search-places-mobile-panel-v3.component';
import {MatTabLink, MatTabNav, MatTabNavPanel} from '@angular/material/tabs';
import {CpruTabsService} from '../../services/cpru-tabs.service';
import {ScrollingModule} from '@angular/cdk/scrolling';
import {SearchWidgetV3DesktopComponent} from './components/search-widget-v3-desktop/search-widget-v3-desktop.component';
import {SearchWidgetV3DesktopExpandedComponent} from './components/search-widget-v3-desktop-expanded/search-widget-v3-desktop-expanded.component';
import {SearchCategoriesV3Component} from './components/search-categories-v3/search-categories-v3.component';
import {SearchPlacesV3Component} from './components/search-places-v3/search-places-v3.component';

@NgModule({
  providers: [SearchWidgetV3StateService, SearchWidgetV3ManagerService, CpruTabsService],
  imports: [
    SharedModule,
    SharedSearchModule,
    RouterModule,
    MatAutocompleteModule,
    UiIconComponent,
    UiButtonComponent,
    UiIconButtonComponent,
    // SearchWidgetV2Module,
    MatTabLink,
    MatTabNavPanel,
    MatTabNav,
    ScrollingModule,
  ],
  declarations: [
    SearchWidgetV3PlaceholderComponent,
    SearchWidgetV3WrapperComponent,
    SearchWidgetV3Component,
    SearchWidgetV3MobileComponent,
    SearchWidgetV3MobileExpandedComponent,
    SearchWidgetV3FreeSearchFormComponent,
    SearchWidgetV3PlacesFormComponent,
    SearchWidgetV3SuggestionsComponent,
    SearchCategoriesMobilePanelV3Component,
    SearchPlacesMobilePanelV3Component,

    SearchWidgetV3DesktopComponent,
    SearchWidgetV3DesktopExpandedComponent,
    SearchCategoriesV3Component,
    SearchPlacesV3Component,
  ],
  exports: [
    SearchWidgetV3PlaceholderComponent,
    SearchWidgetV3WrapperComponent,
    SearchWidgetV3Component,
    SearchWidgetV3MobileComponent,
    SearchWidgetV3MobileExpandedComponent,
    SearchWidgetV3FreeSearchFormComponent,
    SearchWidgetV3PlacesFormComponent,
    SearchWidgetV3SuggestionsComponent,
    SearchCategoriesMobilePanelV3Component,
    SearchPlacesMobilePanelV3Component,

    SearchWidgetV3DesktopComponent,
    SearchWidgetV3DesktopExpandedComponent,
    SearchCategoriesV3Component,
    SearchPlacesV3Component,
  ],
})
export class SearchWidgetV3Module {}
